import { render, staticRenderFns } from "./DataScience.vue?vue&type=template&id=0ad7ca92&"
import script from "./DataScience.vue?vue&type=script&lang=js&"
export * from "./DataScience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports